import React, { Component } from 'react';
import { element } from 'prop-types';
import './PrintLayout.scss';

class PrintLayout extends Component {
  static propTypes = {
    children: element
  };

  render() {
    return (
      <div className="app container-fluid">
        <div className="content">
          <main className="main">{this.props.children}</main>
        </div>
      </div>
    );
  }
}

export default PrintLayout;
